// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"223":"c4ad7b8c","453":"841296c2","701":"81ce86cb","756":"6c768386","945":"03ff7229"}[chunkId] + ".chunk.js";
};